import { createSelector } from "reselect";
const uploadSelector = (state) => state.upload;
const getUploadStatus = createSelector(uploadSelector, upload => upload);
export { getUploadStatus };
